import { ApolloClient, InMemoryCache, from } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { createUploadLink } from 'apollo-upload-client'

import i18n from '@/i18n/index.ts'

let unauthorizedHandler: (() => void) | undefined

export const setUnauthorizedHandler = (handler: () => void) => {
  unauthorizedHandler = handler
}

const httpLink = createUploadLink({
  uri: `${import.meta.env.VITE_APP_API_ENDPOINT}/${import.meta.env.VITE_APP_GQL_ROUTE}`,
})

const cache = new InMemoryCache()

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('access_token')

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      'Accept-Language': i18n.global.locale.value || i18n.global.fallbackLocale,
    },
  }
})

const errorLink = onError(({ networkError }) => {
  if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
    unauthorizedHandler?.()
  }
})

export default new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache,
})
